import React from 'react'
import { FlexColumn } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'
import { CaptionSM, EyebrowMD, TitleLG, TitleMD, TitleXXS } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { useTheatricalPromotionContext } from '@/views/TicketCheckoutViews/ShowtimesView/components/TheatricalPromotionContext'
import { FlexibleBookingToolTip } from '@/views/TicketCheckoutViews/ShowtimesView/components/ToolTips/FlexibleBookingToolTip'
import { SpecificTimesToolTip } from '@/views/TicketCheckoutViews/ShowtimesView/components/ToolTips/SpecificTimesToolTip'
import { NoFeesValuesType } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/config/NoFeesValues'

export const SmallContent = ({ code }: { code: string; bannerValues: NoFeesValuesType }) => {
  const { t } = useTranslate('tickets')
  const { experiments } = useTheatricalPromotionContext()
  const tkokNoFeesExp = experiments ? experiments['tkok-nofees-video'] : undefined

  return (
    <div className="relative mb-2 rounded-xl bg-[#EAE0D9]">
      <div className=" sm relative h-full min-h-[160px] w-full rounded-xl @container/banner ">
        <div className={'relative z-0 h-full min-h-[160px] overflow-hidden  rounded-r-xl'}>
          <div className={'absolute left-0 top-0 z-10   h-[160px] w-full  min-w-[200px]'}>
            <div className={'relative flex w-full justify-end'}>
              <div className="relative right-0 top-0 z-10 block  h-[160px] w-[75px] bg-gradient-to-r  from-[#EAE0D9] to-transparent to-100% " />
              <div className="w-[150px] lg:w-[215px]" />
            </div>
          </div>
          <Image
            src={'https://images.angelstudios.com/image/upload/v1747852104/the-last-rodeo/image.png'}
            className={`rounde-r-xl absolute !-right-0 top-0 h-[100%] w-auto rounded-r-xl object-contain opacity-30 @lg:h-[100%]  `}
            width={200}
            height={140}
            alt={''}
          />
        </div>
        {/* Main content container - absolute positioning to fill parent */}
        <div className="absolute inset-0 z-10 flex w-full items-stretch rounded-xl pl-4 pr-0 @container/content ">
          {/*LEFT TEXT*/}
          <FlexColumn className="flex flex-1 grow justify-center py-1  ">
            <div className={'w-full'}>
              {tkokNoFeesExp ? (
                <>
                  <TitleLG className=" relative" weight="bold" color="black">
                    <Translate i18nKey="theatersaresellingout" t={t}>
                      Theaters Are Selling Out!
                    </Translate>
                  </TitleLG>
                  <TitleXXS color="core-gray-700" weight={'semibold'}>
                    <Translate i18nKey="noonlinefeeswhenbookingtoday" t={t}>
                      No online fees when you book today!
                    </Translate>
                  </TitleXXS>
                </>
              ) : (
                <>
                  <TitleMD color="black" weight={'bold'}>
                    <Translate i18nKey="noOnlineFees" t={t}>
                      No Online Fees.
                    </Translate>
                  </TitleMD>
                  <TitleMD color="black" weight={'bold'}>
                    <Translate i18nKey="NoHassle" t={t}>
                      No Hassle.
                    </Translate>
                  </TitleMD>
                </>
              )}

              {/*TOOLTIP*/}
              <div className={'z-[70] mt-0'}>
                <SpecificTimesToolTip buttonClassName="!px-0" buttonColor={'black'}>
                  <TitleXXS weight={'semibold'}>{t('onSelectShowtimes', 'On Select Showtimes')}</TitleXXS>
                </SpecificTimesToolTip>
                <FlexibleBookingToolTip
                  className="mt-1"
                  buttonColor={'black'}
                  buttonClassName="bg-black/10 border-none text-black focus-visible:outline-none focus-visible:ring-offset-transparent focus-visible:ring-transparent backdrop-blur-[24px] !backdrop-filter"
                />
              </div>
            </div>
          </FlexColumn>
          {/*right text*/}
          <FlexColumn className="flex w-[50%] min-w-[160px] items-center  justify-center">
            <div className={'text-center'}>
              <EyebrowMD weight={'semibold'} className={'uppercase'} color={'black'}>
                {t('usePromoCode', 'Use Promo Code')}
              </EyebrowMD>

              <FlexColumn className={'align-items-center items-center justify-center text-center'}>
                <div className={'my-0 max-w-[118px] justify-center text-center'}>
                  <TitleMD color={'white'} weight={'bold'} className={'bg-[#B22E14] px-4 py-2'}>
                    {code || 'NOFEES'}
                  </TitleMD>
                </div>
              </FlexColumn>
              <EyebrowMD weight={'semibold'} className={'uppercase'} color={'black'}>
                {t('atCheckout', 'At Checkout')}
              </EyebrowMD>
              <div className={'justify-center pr-2 text-center'}>
                <CaptionSM italic weight={'medium'} color="core-gray-700" className={'block !leading-4'}>
                  {t('angelPartneringTheaters', 'Available for Angel Partnering Theaters.')}
                </CaptionSM>
              </div>
            </div>
          </FlexColumn>
        </div>
      </div>
    </div>
  )
}
